export const BROWSER_LOCAL_CACHE_SCHEMA_VERSION = 2
export const BROWSER_LOCAL_CACHE_DB_NAME = 'yijianmai-browser-cache'
export const BROWSER_LOCAL_CACHE_DB_VERSION = 2
export const BROWSER_LOCAL_CACHE_DEFAULT_IMAGE_SOFT_LIMIT_BYTES = 50 * 1024 * 1024
export const BROWSER_LOCAL_CACHE_THUMBNAIL_BLOB_MAX_BYTES = 200 * 1024
export const BROWSER_LOCAL_CACHE_DETAIL_BLOB_MAX_BYTES = 1024 * 1024
export const BROWSER_LOCAL_CACHE_DETAIL_BLOB_TTL_MS = 5 * 60 * 1000
export const BROWSER_LOCAL_CACHE_DEFAULT_API_TTL_MS = 5 * 60 * 1000
export const BROWSER_LOCAL_CACHE_DEFAULT_IMAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000

const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on', 'enabled'])
const FALSE_VALUES = new Set(['0', 'false', 'no', 'off', 'disabled'])

const readViteEnvFlag = (): string => {
  try {
    return String(import.meta.env?.VITE_BROWSER_LOCAL_CACHE_ENABLED ?? '').trim().toLowerCase()
  } catch {
    return ''
  }
}

const inferLocalLikeHost = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }
  const host = String(window.location?.hostname || '').trim().toLowerCase()
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local') || host.includes('staging')
}

export const isBrowserLocalCacheEnabled = (override?: boolean): boolean => {
  if (typeof override === 'boolean') {
    return override
  }
  const flag = readViteEnvFlag()
  if (TRUE_VALUES.has(flag)) return true
  if (FALSE_VALUES.has(flag)) return false
  return inferLocalLikeHost()
}

export const isBrowserLocalCacheDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }
  try {
    return window.localStorage.getItem('debug:browser-local-cache') === '1'
  } catch {
    return false
  }
}
